module.exports = __webpack_public_path__ + "img/bank.ba6745e0.jpg";